import styles from './SingleContact.module.scss';
import { FormattedMessage, useIntl } from 'react-intl';
import Table from 'client/components/aria/Table';
import { Column, TableBody, TableHeader } from 'react-stately';
import singleContactPropTypes from './SingleContactPropTypes';
import PropTypes from 'prop-types';
import { getContactDetailRow } from 'client/pages/MapPage/components/MapInteractions/SelectFeature/featureAttributeHelper';

const SingleContact = ({ departmentName, telephoneNumber, emailAddress, webForm, singleLineAddress, contactDetailsType, hideHeader = false, propertyLabelId = 'contactDetails.property', valueLabelId = 'contactDetails.value', ...props }) => {
    const intl = useIntl();
    const contactRows = getContactDetailRow(departmentName, telephoneNumber, emailAddress, webForm, singleLineAddress, contactDetailsType);
    return <Table
        {...props}
        className={styles.contactTable}
        hideHeader={hideHeader}
        key={ [departmentName, telephoneNumber, emailAddress, contactDetailsType].join('-') }
        aria-label={`${departmentName || ''} ${intl.formatMessage({ id: 'contactDetails.tableLabel' })}`}
        data-testid={props['data-testid'] ? props['data-testid'] + '.contactTable' : null}
    >
        <TableHeader>
            <Column className={styles.propertyColumn}><FormattedMessage id={propertyLabelId}/></Column>
            <Column><FormattedMessage id={valueLabelId}/></Column>
        </TableHeader>
        <TableBody>
            { contactRows }
        </TableBody>
    </Table>;
};

SingleContact.propTypes = {
    'data-testid': PropTypes.string,
    hideHeader: PropTypes.bool,
    propertyLabelId: PropTypes.string,
    valueLabelId: PropTypes.string,
    ...singleContactPropTypes
};

export default SingleContact;
